var getLabelSize = function getLabelSize(props) {
  switch (props.size) {
    case 'small':
      return '12';

    case 'normal':
      return '14';

    case 'large':
      return '16';

    default:
      return '14';
  }
};

export default {
  getLabelSize: getLabelSize
};